




































































import Vue from 'vue'
import Component from 'vue-class-component'
import Typeahead from '@app/componentlib/src/views/components/Typeahead.vue'
import JobSearchFilters from '@app/componentlib/src/views/jobsearch-pages/JobSearchFilters.vue'

import { AppModule } from '@app/componentlib/src/store/modules/app'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'
import { ISearchParams, IUserInfo, IJobPosting, IJobResult, ISettingsItem } from '@app/componentlib/common/types/JobSearchTypes'
import { ILocationItem, IRegion } from '@app/componentlib/common/types/LocationTypes'

import RadiusSlider from '@app/componentlib/src/views/components/location-components/RadiusSlider.vue'
import LocationComponentsContainer from '@app/componentlib/src/views/components/location-components/LocationComponentsContainer.vue'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'
import JobSearchButtons from '@app/componentlib/src/views/jobsearch-pages/JobSearchButtons.vue'

@Component<TopSearch>({
  components: {
    Typeahead,
    JobSearchFilters,
    RadiusSlider,
    LocationComponentsContainer,
    JobSearchButtons
  },
  props: {
    userInfo: Object,
    selectedJobPosting: Object,
    mobileFiltersIsOpen: Boolean,
    startedSearch: Boolean,
    jobsFromPartners: Boolean,
    canSaveSearch: Boolean,
    locationTypeahead: Array,
    settings: Object
  }
})

export default class TopSearch extends Vue {
  /**
   * Props variables
   */
  userInfo: IUserInfo | undefined
  locationTypeahead: ILocationItem[] = []
  selectedJobPosting: IJobPosting | undefined
  mobileFiltersIsOpen: boolean | undefined
  startedSearch!: boolean
  jobsFromPartners!: boolean
  canSaveSearch!: boolean
  settings: ISettingsItem |undefined

  /**
   * Component state variables
   */
  screenWidth: number = window.innerWidth
  tempRegion: IRegion[] = []

  currentInput: string = ""
  locationInput: string = ""

  radiusDropdown = [
      10,
      25,
      50,
      75,
      100
  ]

  locationTypeaheadIsActive: boolean = false
  keywordsTypeaheadIsActive: boolean = false
  filterIsActive: boolean = false
  showAllSearchStrings: boolean = false

  /**
   * Lifecycle
   */
  async mounted() {
    this.clearSearch()
    await LocationModule.init(this.userInfo?.countryCode || 'DK')
    this.showAllSearchStrings = this.isMobile === true ? false : true
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get jobResult (): IJobResult | undefined {
    return JobSearchModule.jobResult
  }

  get getFilterStrings (): string[] {
    if (this.searchParams === undefined || this.searchParams.FilterStrings === undefined)
      return []

    return this.searchParams.FilterStrings
  }

  get searchParams (): ISearchParams | undefined {
    return JobSearchModule.searchParams
  }

  get locations (): IRegion[] {
    return LocationModule.locations
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  /**
   * Methods
   */
  startSearch(): void {
    if (this.currentInput.length > 1)
      this.addKeyword()

    this.locationTypeaheadIsActive = false
    this.keywordsTypeaheadIsActive = false
    this.$emit('startSearch', false)
  }

  // Clear search and its related variables
  clearSearch() {
    this.$emit('clearSearch')
    this.locationInput = ""
    this.currentInput = ""
    let today = new Date()
    JobSearchModule.setSearchParams({
      Id: 0,
      Page: 0,
      SearchName: "",
      FilterStrings: [],
      MatchAll: false,
      TextSearch: false,
      Country: "DK",
      ZipCode: undefined,
      Range: 10,
      StartDate:  new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14),
      StartDateString: "",
      IndustryFilter: [],
      CareerFilter: [],
      JobCategoryFilter: [],
      paramsName: "new",
      PartnersOnly: this.jobsFromPartners,
      CityName: ""
    } as ISearchParams)
    LocationModule.setLocation([])
    JobSearchModule.setJobKeywords([])
  }

  addKeyword() {
    if (this.currentInput != '' && this.currentInput.length > 1) {
      let params = this.searchParams!
      params?.FilterStrings.push(this.currentInput)
      JobSearchModule.setSearchParams(params)
      this.currentInput = ""
    }

    this.$emit('emitParams')
  }

  removeKeyword(keyword: string) {
    let params = this.searchParams!
    params.FilterStrings = this.getFilterStrings?.filter(obj => obj !== keyword)
    JobSearchModule.setSearchParams(params)
  }

  openKeywordsTypeahead(bool: boolean) {
    this.keywordsTypeaheadIsActive = bool
  }

  changeFilterIsActive() {
    this.filterIsActive = !this.filterIsActive
  }

  changeShowOverlay(bool: boolean) {
    this.$emit('changeShowOverlay', bool)
  }

  goToPage(url?: string) {
    if(url !== null && url !== "") {
      window.open(url, '_blank', 'noopener,noreferrer')?.focus();
    }
  }

  changeMobileFiltersIsOpen(bool: boolean) {
    this.$emit('changeMobileFiltersIsOpen', bool)
  }

  openSaveSearchModal() {
    this.$emit('openSaveSearchModal')
  }

  inputChanged(input: string) {
    this.locationInput = input
  }
  showAll() {
    this.showAllSearchStrings = !this.showAllSearchStrings
  }
}
